<template>
  <div data-test-id="DashboardComponent" class="watermark dashboard">
    <div class="row">
      <div class="col">
        <AgencyInfo :selected-ems-agency="selectedEMSAgency" />
      </div>
    </div>

    <div v-if="selectedEMSAgency" class="row">
      <div class="col">
        <DailyCasesByPriorityChartContainer
          :chart-data="reportValues0"
          :count="casesCount"
          :data1="reportValues1"
          :data2="reportValues2"
          :data3="reportValues3"
          :labels="reportDates"
          :loaded="casesLoaded"
          :loading="casesLoading"
          :is-admin="isAdmin"
          :timespan="timespan"
        />
      </div>
    </div>

    <div v-if="selectedEMSAgency" style="margin-top: 3.5rem;">
      <div class="row">
        <div class="col-sm-4">
          <Overview
            :data="{
              memberCount,
              trucksCount,
              casesCountToday,
              casesCount
            }"
            :is-admin="isAdmin"
            :timespan="timespan"
          />
        </div>
        <div class="col-sm-4">
          <TopCaseCreators v-if="isAdmin" aggregate-by="emsUser" :data="data30Days" size="5" :timespan="timespan" />
        </div>
        <div class="col-sm-4">
          <TopDestinationHospitals
            aggregate-by="hospital.name"
            :data="data30Days"
            :is-admin="isAdmin"
            :timespan="timespan"
            size="5"
          />
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div style="margin-top: 2.5rem;">
            <feedback />
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <div style="margin-bottom: 1rem; margin-top: 2.5rem;">
          <contact-info />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { AgencyInfo } from "@/App/components";
import ContactInfo from "@/App/components/ContactInfo.vue";
import { DailyCasesByPriorityChartContainer } from "@/Dashboard/components";
import Overview from "@/Dashboard/components/Overview/Overview";
import TopCaseCreators from "@/Dashboard/components/TopCaseCreators/TopCaseCreators";
import TopDestinationHospitals from "@/Dashboard/components/TopDestinationHospitals/TopDestinationHospitals";

export default {
  name: "Dashboard",
  components: {
    AgencyInfo,
    ContactInfo,
    DailyCasesByPriorityChartContainer,
    Overview,
    TopCaseCreators,
    TopDestinationHospitals
  },
  props: {
    agencies: {
      default: () => ({}),
      type: Object
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("Login", ["selectedEMSAgency", "isAdmin", "authToken"]),
    ...mapGetters("Trucks", {
      trucksCount: "totalItems"
    }),
    ...mapGetters("Users", {
      users: "data",
      memberCount: "memberCount"
    }),
    ...mapGetters("Cases", {
      casesCount: "totalItems",
      casesCountToday: "totalItemsToday",
      data30Days: "data30Days",
      reportDates: "casesPerDayReportDates",
      reportValues0: "casesPerDayReportValuesPriority0",
      reportValues1: "casesPerDayReportValuesPriority1",
      reportValues2: "casesPerDayReportValuesPriority2",
      reportValues3: "casesPerDayReportValuesPriority3"
    }),
    ...mapState("Cases", ["timespan"]),
    ...mapGetters("Global", {
      casesLoaded: "loaded",
      casesLoading: "isLoading"
    })
  }
};
</script>

<style scoped>
.dashboard {
  text-align: left;
}
.watermark {
  background-attachment: fixed;
  background-image: url("../assets/RedBird.svg");
  background-position: center;
  background-repeat: no-repeat;
}
</style>
